<div class="sidebar" [class.collapsed]="!isExpanded">
    <div class="sidebar-header">
      <div class="logo-container" *ngIf="isExpanded">
        <span class="logo-text">Eletroservice</span>
      </div>
      <button class="toggle-btn" (click)="handleToggle()">
        <i [class]="isExpanded ? 'bi bi-chevron-left' : 'bi bi-list'"></i>
      </button>
    </div>
  
    <nav class="sidebar-nav">
      <ul>
        <li *ngFor="let item of menuItems">
          <a [routerLink]="item.route" 
             [routerLinkActive]="'active'" 
             [routerLinkActiveOptions]="{ exact: item.exact }"
             class="nav-link">
            <i [class]="item.icon"></i>
            <span class="link-text" *ngIf="isExpanded">{{ item.label }}</span>
          </a>
        </li>
      </ul>
    </nav>
  
    <div class="sidebar-footer">
      <div class="user-info" *ngIf="isExpanded">
        <span class="user-name"></span>
      </div>
      <button class="logout-btn" (click)="logout()">
        <span *ngIf="isExpanded" class="mr-2">Sair</span>
        <i class="bi bi-box-arrow-left"></i>
      </button>
    </div>
  </div>